import { Component } from '@angular/core';
import { VideoControlsComponent } from '../video-controls/video-controls.component';

@Component({
  selector: 'studio-progress-scrubber',
  templateUrl: './progress-scrubber.component.html',
  styleUrls: ['./progress-scrubber.component.scss'],
})
export class ProgressScrubberComponent {
  constructor(protected videoControls: VideoControlsComponent) {}

  scrubVideo(time: number) {
    this.videoControls.video.currentTime = time;
  }
}
